import { Link } from '@tanstack/react-router'
import type { useBouquetSectionModel } from '@/components/home/components/bouquet-section/bouquet-section.model'

type BouquetSectionViewProps = ReturnType<typeof useBouquetSectionModel>

export function BouquetSectionView({
  sectionTitle,
  headingText,
  kickerText,
  kickerStyle,
  tags,
  catalogItems,
  stageInert,
}: BouquetSectionViewProps) {
  return (
    <section className="fz-bouquet">
      <h2 className="fz-sr-only">{headingText}</h2>
      <nav className="fz-sr-only" aria-label={sectionTitle}>
        <ul>
          {catalogItems.map((item) => (
            <li key={item.slug}>
              <Link to="/produto/$slug" params={{ slug: item.slug }}>
                {item.name} — {item.formattedPrice}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
      <div
        className="fz-bouquet__stage"
        inert={stageInert || undefined}
        aria-hidden="true"
      >
        <p className="fz-bouquet__kicker" style={kickerStyle}>
          {kickerText}
        </p>
        <ul className="fz-bouquet__tags">
          {tags.map((tag) => (
            <li
              key={tag.slug}
              className={`fz-bouquet__tag fz-bouquet__tag--${tag.side}`}
              style={tag.style}
            >
              <Link
                to="/produto/$slug"
                params={{ slug: tag.slug }}
                className="fz-bouquet__tag-link"
                tabIndex={-1}
              >
                <span className="fz-bouquet__tag-name">{tag.name}</span>
                <span className="fz-bouquet__tag-price">
                  {tag.formattedPrice}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
